import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import Alert from '@material-ui/lab/Alert';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import classNames from 'classnames';

import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';

import CircularProgress from 'components/shared/CircularProgress';
import DialogTemplate from 'components/shared/DialogTemplate';
import Dac7ListItem from './Dac7ListItem';

import { clearAllErrorAndIsLoading, fetchAvailableYearsRequest } from '../redux/actionCreators';
import * as selectors from '../redux/selectors';

import { FETCH_AVAILABLE_YEARS_REQUEST } from '../redux/actionTypes';

const styles = makeStyles((theme) => ({
  button: {
    marginLeft: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  text: {
    padding: theme.spacing(2),
    paddingBottom: 0,
  },
  dialog: {
    [theme.breakpoints.up('md')]: {
      minWidth: 640,
    },
  },
  dialogPaper: {
    overflow: 'hidden',
  },
  dialogPaperWide: {
    [theme.breakpoints.up('md')]: {
      maxWidth: 840,
    },
  },
  customDialogContent: {
    padding: theme.spacing(0),
    '&:first-child': {
      paddingTop: theme.spacing(0),
    },
  },
}));

const Dac7InfoDialog = ({
  onClose,
  isLoading,
  error,
  availableYears,
  fetchAvailableYearsReq,
}) => {
  const classes = styles();

  const theme = useTheme();
  const fullscreen = useMediaQuery(theme.breakpoints.down('xs'));

  const dispatch = useDispatch();

  const handleCloseDialog = () => {
    dispatch(clearAllErrorAndIsLoading());
    onClose();
  };

  useEffect(() => {
    if (!error && (!availableYears || availableYears.length === 0)) {
      fetchAvailableYearsReq();
    }
  }, []);

  const years = availableYears || [];
  const isError = error && Object.keys(error).length > 0;

  return (
    <Dialog
      open
      onClose={onClose}
      fullScreen={fullscreen}
      fullWidth
      maxWidth="md"
      classes={{
        paper: classNames(
          classes.dialogPaper,
        ),
      }}
    >
      <DialogContent className={classes.customDialogContent}>
        <DialogTemplate
          title={(
            <FormattedMessage
              id="dac7.info"
              defaultMessage="DAC7 Info"
            />
          )}
          onClose={handleCloseDialog}
        >
          {isLoading && <CircularProgress />}
          {isError && <Alert severity="error" elevation={3}><FormattedMessage id="dac7.fetch.error" defaultMessage="An error occurred while fetching data" /></Alert>}
          {years.map((year) => (
            <Dac7ListItem
              key={year}
              year={year}
            />
          ))}
        </DialogTemplate>
      </DialogContent>
    </Dialog>
  );
};

Dac7InfoDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  error: PropTypes.shape({}),
  isLoading: PropTypes.bool,
  availableYears: PropTypes.arrayOf(PropTypes.number),
  fetchAvailableYearsReq: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  availableYears: selectors.getAvailableYears(state),
  error: selectors.error(state, FETCH_AVAILABLE_YEARS_REQUEST),
  isLoading: selectors.isLoading(state, FETCH_AVAILABLE_YEARS_REQUEST),
});

export default connect(mapStateToProps, { fetchAvailableYearsReq: fetchAvailableYearsRequest })(Dac7InfoDialog);
